import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Steps, Upload, Modal, Tooltip } from 'antd';
import './style.css';
import jsPDF from 'jspdf';
import featured_icon from '../../../../../assets/icons/Featured_icon.png';
import button_icon from '../../../../../assets/icons/button_icon.png';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import CustomProgress from '../../../../../common/Layout/CustomProgress';
import * as XLSX from 'xlsx';

import { useDispatch } from 'react-redux';
import { isError } from 'lodash';

const { Step } = Steps;
const { Dragger } = Upload;

const safeNumberConversion = (value) => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }
  const num = Number(value);
  return isNaN(num) ? 0 : num;
};

const UploadFiles = ({
  fileList,
  setFileList,
  allExtractedData,
  setAllExtractedData,
  setIsUploading,
}) => {
  const dispatch = useDispatch();

  const [currentStep, setCurrentStep] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [isError, setIsError] = useState('');
  const allErrorsList = [];

  const handleCheckboxChange = (e) => {
    const newCheckedState = e.target.checked; // Desired new state (checked/unchecked)

    if (newCheckedState) {
      // Show modal only when trying to check the checkbox
      Modal.confirm({
        title: 'Alert!',
        content:
          ' Please follow the rules you have already read and agreed to, for a successful file upload',
        okButtonProps: {
          className: 'next-button', // Add your custom class here
        },
        cancelButtonProps: {
          className: 'prev-button', // Add your custom class here
        },
        onOk: () => {
          setIsChecked(true); // Confirm and set checkbox as checked
        },
        onCancel: () => {
          // Do nothing; keep checkbox unchecked
        },
      });
    } else {
      // Directly uncheck without modal
      setIsChecked(false);
    }
  };

  const expectedHeaders = {
    diameter: [
      'Dia of Bar',
      'Size',
      'Bar dia. (mm)',
      'Dia Of Bar',
      'Dia (mm)',
      'Bar Dia.',
    ],
    numberOfBars: [
      'Total No. of Bars',
      'Total № Bar',
      'No. Of Bars',
      '№ of Bars',
      'No of Bars',
      'Total Nos',
      'Total Nos. of Bar',
      'Nos. Of Bars',
    ],
    cutLength: [
      'Cutting Length (mm)',
      'Total Length of Bar',
      'Cutting Length (mm)',
      'Cutting length',
      'Cut Length (Mts.)',
      'Cutting Length in MM',
      'Cut Length In Metres',
      'Cutting Length in (MM)',
    ],
  };

  const [form] = Form.useForm();

  const [deletedFiles, setDeletedFiles] = useState([]);

  const prevStep = () => setCurrentStep(currentStep - 1);

  console.log('All Extracted Data@@@@@@@@@:', allExtractedData);

  // Add findHeaderLocations helper function
  // const findHeaderLocations = (worksheet) => {
  //   const range = XLSX.utils.decode_range(worksheet['!ref']);
  //   const headerLocations = {};

  //   for (let row = range.s.r; row <= range.e.r; row++) {
  //     for (let col = range.s.c; col <= range.e.c; col++) {
  //       const cellRef = XLSX?.utils?.encode_cell({ r: row, c: col });
  //       const cell = worksheet[cellRef];

  //       if (!cell || !cell?.v) continue;

  //       const cellValue = cell?.v?.toString()?.toLowerCase().trim();

  //       Object.entries(expectedHeaders).forEach(([category, validHeaders]) => {
  //         const matchingHeader = validHeaders.find(
  //           (header) => cellValue === header?.toLowerCase().trim(),
  //         );

  //         if (matchingHeader) {
  //           headerLocations[category] = {
  //             row,
  //             col,
  //             header: matchingHeader,
  //             ref: cellRef,
  //           };
  //         }
  //       });
  //     }
  //   }

  //   return headerLocations;
  // };
  const findHeaderLocations = (worksheet) => {
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    const headerLocations = {};
    const foundHeadersMap = new Map(); // Track found headers

    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellRef = XLSX?.utils?.encode_cell({ r: row, c: col });
        const cell = worksheet[cellRef];

        if (!cell || !cell?.v) continue;

        const cellValue = cell?.v?.toString()?.toLowerCase().trim();

        Object.entries(expectedHeaders).forEach(([category, validHeaders]) => {
          const matchingHeader = validHeaders.find(
            (header) => cellValue === header?.toLowerCase().trim(),
          );

          if (matchingHeader) {
            // Check for duplicates
            const headerKey = `${category}-${matchingHeader.toLowerCase()}`;
            if (foundHeadersMap.has(headerKey)) {
              const existingLocation = foundHeadersMap.get(headerKey);
              throw new Error(
                JSON.stringify({
                  type: 'duplicate',
                  header: matchingHeader,
                  category,
                  firstLocation: existingLocation,
                  duplicateLocation: `${XLSX.utils.encode_col(col)}${row + 1}`,
                }),
              );
            }
            // Store header location
            foundHeadersMap.set(
              headerKey,
              `${XLSX.utils.encode_col(col)}${row + 1}`,
            );

            headerLocations[category] = {
              row,
              col,
              header: matchingHeader,
              ref: cellRef,
            };
          }
        });
      }
    }

    return headerLocations;
  };
  // const extractColumnData = (worksheet, headers, expectedHeaders) => {
  //   // Get all rows including headers
  //   const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  //   // console.log('All rows:', rows);

  //   // Get header row and clean it
  //   const headerRow = rows[0].map((h) => (h ? h.toString().trim() : ''));
  //   // console.log('Header row:', headerRow);

  //   // Create header mapping
  //   const headerMapping = {};
  //   Object.entries(expectedHeaders).forEach(([category, validHeaders]) => {
  //     for (let i = 0; i < headerRow.length; i++) {
  //       const currentHeader = headerRow[i]?.toLowerCase();
  //       if (
  //         validHeaders.some((valid) =>
  //           currentHeader.includes(valid?.toLowerCase()),
  //         )
  //       ) {
  //         headerMapping[category] = i;
  //         break;
  //       }
  //     }
  //   });
  //   // console.log('Header mapping:', headerMapping);

  //   // Get data rows
  //   const dataRows = rows
  //     .slice(1)
  //     .filter((row) => row.some((cell) => cell != null && cell !== ''));
  //   // console.log('Data rows:', dataRows);

  //   // Map data to objects
  //   const formattedData = dataRows
  //     .filter((row) => {
  //       // Verify all required columns have numeric values
  //       return Object.values(headerMapping).every((colIndex) => {
  //         const value = row[colIndex];
  //         const isValid = value != null && value !== '' && !isNaN(value);
  //         return isValid;
  //       });
  //     })
  //     .map((row) => {
  //       // Create object with mapped values
  //       const obj = {};
  //       Object.entries(headerMapping).forEach(([category, colIndex]) => {
  //         obj[category] = Number(row[colIndex]);
  //       });

  //       // Handle cut length splitting
  //       if (obj.cutLength > 12000) {
  //         return [
  //           { ...obj, cutLength: 12000 },
  //           { ...obj, cutLength: obj.cutLength - 12000 },
  //         ];
  //       }
  //       return obj;
  //     })
  //     .flat();

  //   // console.log('Formatted data:', formattedData);
  //   return formattedData;
  // };
  // const validateExcelHeaders = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const isExcel =
  //       file.type ===
  //         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
  //       file.name.endsWith('.xlsx');

  //     if (!isExcel) {
  //       reject('Invalid file type. Please upload an Excel file.');
  //       return;
  //     }

  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       try {
  //         const data = new Uint8Array(e.target.result);
  //         const workbook = XLSX.read(data, { type: 'array' });
  //         let allErrors = [];
  //         let extractedData = [];

  //         workbook.SheetNames.forEach((sheetName) => {
  //           const worksheet = workbook.Sheets[sheetName];
  //           const headerLocations = findHeaderLocations(worksheet);

  //           // Check missing headers
  //           Object.keys(expectedHeaders).forEach((category) => {
  //             if (!headerLocations[category]) {
  //               allErrors.push({
  //                 type: 'missingHeader',
  //                 sheet: sheetName,
  //                 category,
  //                 // message: `Missing column "${expectedHeaders[category].join('" or "')}" in sheet "${sheetName}"`
  //                 message: `Missing column: '${category}' in sheet "${sheetName}"`,
  //               });
  //             }
  //           });

  //           // Scan for watermarks and images
  //           const range = XLSX.utils.decode_range(worksheet['!ref']);

  //           for (let row = range.s.r; row <= range.e.r; row++) {
  //             for (let col = range.s.c; col <= range.e.c; col++) {
  //               const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
  //               const cell = worksheet[cellRef];

  //               if (!cell) continue;

  //               // Check watermarks
  //               if (
  //                 cell?.v &&
  //                 typeof cell?.v === 'string' &&
  //                 cell?.v?.toLowerCase().includes('watermark')
  //               ) {
  //                 allErrors.push({
  //                   type: 'watermark',
  //                   sheet: sheetName,
  //                   cell: cellRef,
  //                   row: row + 1,
  //                   col: XLSX.utils.encode_col(col),
  //                   message: `Watermark found in sheet "${sheetName}" at cell ${XLSX.utils.encode_col(col)}${row + 1}`,
  //                 });
  //               }

  //               // Check images in data columns
  //               Object.entries(headerLocations).forEach(
  //                 ([category, location]) => {
  //                   if (col === location.col && row > location.row) {
  //                     const hasImage =
  //                       cell.t === 'e' ||
  //                       (cell.l &&
  //                         /\.(png|jpg|jpeg|gif|bmp)$/i.test(cell.l.Target)) ||
  //                       cell._type === 'image' ||
  //                       (cell?.v &&
  //                         typeof cell?.v === 'string' &&
  //                         cell?.v.includes('BITMAP'));

  //                     if (hasImage) {
  //                       allErrors.push({
  //                         type: 'image',
  //                         sheet: sheetName,
  //                         category,
  //                         cell: cellRef,
  //                         row: row + 1,
  //                         col: XLSX.utils.encode_col(col),
  //                         message: `Image found in "${category}" column at cell ${XLSX.utils.encode_col(col)}${row + 1} in sheet "${sheetName}"`,
  //                       });
  //                     }
  //                   }
  //                 },
  //               );
  //             }
  //           }

  //           // If no errors, extract data
  //           if (allErrors?.length === 0) {
  //             const sheetData = extractColumnData(
  //               worksheet,
  //               headerLocations,
  //               expectedHeaders,
  //             );

  //             if (Array.isArray(sheetData) && sheetData.length > 0) {
  //               const mappedData = sheetData.map((item) => ({
  //                 ...item,
  //                 fileUid: file.uid,
  //                 fileName: file.name,
  //                 sheetName,
  //               }));

  //               if (Array.isArray(extractedData)) {
  //                 extractedData.push(...mappedData);
  //               } else {
  //                 extractedData = mappedData;
  //               }
  //             }
  //           }
  //         });

  //         if (allErrors.length > 0) {
  //           // Show error popup with all validation errors
  //           const errorPopup = document.createElement('div');
  //           errorPopup.classList.add('popup-overlay');

  //           const errorMessages = allErrors
  //             .map(
  //               (error) =>
  //                 `<p style="color: ${error.type === 'watermark' ? 'red' : 'inherit'}">${error.message}</p>`,
  //             )
  //             .join('');

  //           errorPopup.innerHTML = `
  //           <div class="popup-container">
  //             <button class="popup-close">&times;</button>
  //             <h2 class="popup-heading">File Upload Failed</h2>
  //              <p class="popup-para">Below details have not been entered into the standard format.
  //                 Please re-upload the file(s) after making the changes.</p>
  //             <div class="popup-message">${errorMessages}</div>
  //           </div>
  //         `;

  //           document.body.appendChild(errorPopup);
  //           document
  //             .querySelector('.popup-close')
  //             .addEventListener('click', () => {
  //               document.body.removeChild(errorPopup);
  //             });

  //           reject(new Error('Validation failed'));
  //         } else {
  //           setAllExtractedData((prev) => [...prev, ...extractedData]);
  //           resolve();
  //         }
  //       } catch (error) {
  //         const errorPopup = document.createElement('div');
  //         errorPopup.classList.add('popup-overlay');

  //         errorPopup.innerHTML = `
  //         <div class="popup-container">
  //           <button class="popup-close">&times;</button>
  //           <h2 class="popup-heading">File Error</h2>
  //           <p class="popup-para">Unable to process file: <span>${'Invalid file format'}</span>
  //           </p>
  //         </div>
  //       `;
  //         /*  <div class="popup-message">
  //             <p>${error.message || 'Invalid file format'}</p>
  //           </div> */
  //         document.body.appendChild(errorPopup);
  //         document
  //           .querySelector('.popup-close')
  //           .addEventListener('click', () => {
  //             document.body.removeChild(errorPopup);
  //           });

  //         reject(error.message || 'Error reading file');
  //       }
  //     };

  //     reader.readAsArrayBuffer(file);
  //   });
  // };

  //OLD EXTRACTCOLUMNDATA FUNCTION----

  // const extractColumnData = (worksheet, headerLocations, expectedHeaders) => {
  //   console.log('Starting data extraction with headers:', headerLocations);

  //   const range = XLSX.utils.decode_range(worksheet['!ref']);
  //   const data = [];

  //   // Debug header locations
  //   for (const [category, location] of Object.entries(headerLocations)) {
  //     console.log(
  //       `Header ${category} found at row: ${location.row}, col: ${location.col}`,
  //     );
  //   }

  //   // Start from the row after headers
  //   const startRow =
  //     Math.max(...Object.values(headerLocations).map((loc) => loc.row)) + 1;

  //   for (let row = startRow; row <= range.e.r; row++) {
  //     const rowData = {};
  //     let hasData = false;

  //     // Extract data for each category
  //     for (const [category, location] of Object.entries(headerLocations)) {
  //       const cellRef = XLSX?.utils?.encode_cell({ r: row, c: location.col });
  //       const cell = worksheet[cellRef];

  //       if (cell && cell?.v !== undefined) {
  //         // rowData[category] = cell?.v;
  //         // Round cutLength to 2 decimals
  //         try {
  //           if (category === 'cutLength') {
  //             const value = safeNumberConversion(cell?.v);
  //             rowData[category] = Number(value?.toFixed(2));
  //           } else if (category === 'numberOfBars') {
  //             const value = safeNumberConversion(cell?.v);
  //             rowData[category] = Math?.floor(value);
  //           } else {
  //             rowData[category] = safeNumberConversion(cell?.v);
  //           }
  //           hasData = true;
  //         } catch (error) {
  //           console.log(
  //             `Found data at ${cellRef}: ${cell?.v} for category ${category}`,
  //           );
  //           console.error(`Error processing ${category} value:`, cell?.v);
  //           rowData[category] = 0;
  //         }
  //       }
  //     }

  //     // Only add rows that have data
  //     // if (hasData) {
  //     //   data.push(rowData);
  //     // }
  //     if (hasData) {
  //       // Split rows if cutLength > 12000
  //       if (rowData.cutLength > 12000) {
  //         // First row with 12000 length
  //         data.push({
  //           ...rowData,
  //           cutLength: 12000,
  //         });

  //         // Second row with remaining length
  //         data.push({
  //           ...rowData,
  //           // cutLength: rowData.cutLength - 12000,
  //           cutLength: Number((rowData?.cutLength - 12000)?.toFixed(2)),
  //         });
  //       } else {
  //         data.push(rowData);
  //       }
  //     }
  //   }

  //   console.log('Extracted data:', data);
  //   return data.length > 0 ? data : null;
  // };

  const extractColumnData = (worksheet, headerLocations, expectedHeaders) => {
    console.log('Starting data extraction with headers:', headerLocations);

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    const data = [];

    for (const [category, location] of Object.entries(headerLocations)) {
      console.log(
        `Header ${category} found at row: ${location.row}, col: ${location.col}`,
      );
    }

    const startRow =
      Math.max(...Object.values(headerLocations).map((loc) => loc.row)) + 1;

    for (let row = startRow; row <= range.e.r; row++) {
      const rowData = {};
      let hasData = false;

      for (const [category, location] of Object.entries(headerLocations)) {
        const cellRef = XLSX?.utils?.encode_cell({ r: row, c: location.col });
        const cell = worksheet[cellRef];

        if (cell && cell?.v !== undefined) {
          try {
            if (category === 'cutLength') {
              const value = safeNumberConversion(cell?.v);
              rowData[category] = Number(value?.toFixed(2));
            } else if (category === 'numberOfBars') {
              const value = safeNumberConversion(cell?.v);
              rowData[category] = Math?.floor(value);
            } else {
              rowData[category] = safeNumberConversion(cell?.v);
            }
            hasData = true;
          } catch (error) {
            console.log(
              `Found data at ${cellRef}: ${cell?.v} for category ${category}`,
            );
            console.error(`Error processing ${category} value:`, cell?.v);
            rowData[category] = 0;
          }
        }
      }

      const requiredFields = ['diameter', 'numberOfBars', 'cutLength'];
      const hasAllRequiredFields = requiredFields.every((field) => {
        return Object.keys(expectedHeaders).includes(field) && rowData[field];
      });

      if (hasData && hasAllRequiredFields) {
        // Split rows if cutLength > 12000
        if (rowData.cutLength > 12000) {
          data.push({
            ...rowData,
            cutLength: 12000,
          });

          data.push({
            ...rowData,
            cutLength: Number((rowData?.cutLength - 12000)?.toFixed(2)),
          });
        } else {
          data.push(rowData);
        }
      } else {
        console.warn(
          `Row ${row} skipped due to missing mandatory fields:`,
          rowData,
        );
      }
    }

    console.log('Extracted data:', data);
    return data.length > 0 ? data : null;
  };

  // const validateExcelHeaders = (file) => {
  //   return new Promise((resolve, reject) => {
  //     // Check file type
  //     // const isExcel =
  //     //   file.type ===
  //     //     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
  //     //   file.name.endsWith('.xlsx');

  //     // if (!isExcel) {
  //     //   reject('Invalid file type. Please upload an Excel file.');
  //     //   return;
  //     // }

  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       try {
  //         const data = new Uint8Array(e.target.result);
  //         const workbook = XLSX.read(data, { type: 'array' });
  //         let allErrors = [];
  //         let extractedData = [];
  //         console.log('workbook:', workbook);
  //         // Process each sheet
  //         workbook.SheetNames.forEach((sheetName) => {
  //           const worksheet = workbook.Sheets[sheetName];
  //           console.log(`Analyzing sheet: ${sheetName}`);

  //           const range = XLSX.utils.decode_range(worksheet['!ref']);
  //           let sheetWatermarkFound = false;

  //           // First check for watermarks
  //           for (
  //             let row = range.s.r;
  //             row <= range.e.r && !sheetWatermarkFound;
  //             row++
  //           ) {
  //             for (let col = range.s.c; col <= range.e.c; col++) {
  //               const cellRef = XLSX?.utils?.encode_cell({ r: row, c: col });
  //               const cell = worksheet[cellRef];

  //               if (
  //                 cell?.v &&
  //                 typeof cell?.v === 'string' &&
  //                 cell?.v?.toLowerCase().includes('watermark')
  //               ) {
  //                 allErrors.push({
  //                   type: 'watermark',
  //                   sheet: sheetName,
  //                   message: `Watermark found in sheet "${sheetName}"`,
  //                 });
  //                 sheetWatermarkFound = true;
  //                 break;
  //               }
  //             }
  //           }

  //           // Only proceed with other validations if no watermark found
  //           if (!sheetWatermarkFound) {
  //             // Find headers
  //             const headerLocations = findHeaderLocations(worksheet);
  //             console.log('Header locations:', headerLocations);
  //             // Check for missing headers
  //             Object.keys(expectedHeaders).forEach((category) => {
  //               if (!headerLocations[category]) {
  //                 allErrors.push({
  //                   type: 'missingHeader',
  //                   sheet: sheetName,
  //                   category,
  //                   message: `Missing column '${category}' in sheet "${sheetName}"`,
  //                 });
  //               }
  //             });

  //             // Check for images in data columns
  //             for (let row = range.s.r; row <= range.e.r; row++) {
  //               for (let col = range.s.c; col <= range.e.c; col++) {
  //                 const cellRef = XLSX?.utils?.encode_cell({ r: row, c: col });
  //                 const cell = worksheet[cellRef];

  //                 if (!cell) continue;

  //                 Object.entries(headerLocations).forEach(
  //                   ([category, location]) => {
  //                     if (col === location.col && row > location.row) {
  //                       const hasImage =
  //                         cell.t === 'e' ||
  //                         (cell.l &&
  //                           /\.(png|jpg|jpeg|gif|bmp)$/i.test(cell.l.Target)) ||
  //                         cell._type === 'image' ||
  //                         (cell?.v &&
  //                           typeof cell?.v === 'string' &&
  //                           cell?.v.includes('BITMAP'));

  //                       if (hasImage) {
  //                         allErrors.push({
  //                           type: 'image',
  //                           sheet: sheetName,
  //                           category,
  //                           cell: cellRef,
  //                           row: row + 1,
  //                           col: XLSX.utils.encode_col(col),
  //                           message: `Image found in "${category}" column at cell ${XLSX.utils.encode_col(col)}${row + 1} in sheet "${sheetName}"`,
  //                         });
  //                       }
  //                     }
  //                   },
  //                 );
  //               }
  //             }

  //             // If no errors, extract data
  //             if (allErrors.length === 0) {
  //               const sheetData = extractColumnData(
  //                 worksheet,
  //                 headerLocations,
  //                 expectedHeaders,
  //               );
  //               console.log('Sheet Data@@@@@@@@@:', sheetData);
  //               if (Array.isArray(sheetData) && sheetData.length > 0) {
  //                 const mappedData = sheetData.map((item) => ({
  //                   ...item,
  //                   fileUid: file.uid,
  //                   fileName: file.name,
  //                   sheetName,
  //                 }));

  //                 if (Array.isArray(extractedData)) {
  //                   extractedData.push(...mappedData);
  //                 } else {
  //                   extractedData = mappedData;
  //                 }
  //               }
  //             }
  //           }
  //         });

  //         // Handle errors or success
  //         if (allErrors.length > 0) {
  //           const errorPopup = document.createElement('div');
  //           errorPopup.classList.add('popup-overlay');

  //           // Prioritize watermark errors
  //           const watermarkErrors = allErrors.filter(
  //             (e) => e.type === 'watermark',
  //           );
  //           const errorMessages =
  //             watermarkErrors.length > 0
  //               ? watermarkErrors
  //                   .map(
  //                     (error) => `<p style="color: red">${error.message}</p>`,
  //                   )
  //                   .join('')
  //               : allErrors.map((error) => `<p>${error.message}</p>`).join('');

  //           errorPopup.innerHTML = `
  //             <div class="popup-container">
  //               <button class="popup-close">&times;</button>
  //               <h2 class="popup-heading">File Upload Failed</h2>
  //               <p class="popup-para">Please correct the following issues:</p>
  //               <div class="popup-message">${errorMessages}</div>
  //             </div>
  //           `;

  //           document.body.appendChild(errorPopup);
  //           document
  //             .querySelector('.popup-close')
  //             .addEventListener('click', () => {
  //               document.body.removeChild(errorPopup);
  //             });

  //           reject(new Error('Validation failed'));
  //         } else {
  //           setAllExtractedData((prev) => [...prev, ...extractedData]);
  //           resolve();
  //         }
  //       } catch (error) {
  //         const errorPopup = document.createElement('div');
  //         errorPopup.classList.add('popup-overlay');
  //         // Custom message for indexOf undefined error
  //         const errorMessage = error.message.includes(
  //           "Cannot read properties of undefined (reading 'indexOf')",
  //         )
  //           ? 'Unable to process the file due to its invalid format.'
  //           : error.message;
  //         // errorPopup.innerHTML = `
  //         //   <div class="popup-container">
  //         //     <button class="popup-close">&times;</button>
  //         //     <h2 class="popup-heading">File Error</h2>
  //         //     <p class="popup-para">Unable to process the file as its format is either invalid or it is protected.</p>
  //         //     <p class="popup-para">${error.message}.</p>
  //         //   </div>
  //         errorPopup.innerHTML = `
  //               <div class="popup-container">
  //                 <button class="popup-close">&times;</button>
  //                 <h2 class="popup-heading">File Error</h2>
  //                 <p class="popup-para">${errorMessage}.</p>
  //               </div>
  //         `;
  //         document.body.appendChild(errorPopup);
  //         document
  //           .querySelector('.popup-close')
  //           .addEventListener('click', () => {
  //             document.body.removeChild(errorPopup);
  //           });

  //         reject(error);
  //       }
  //     };

  //     reader.readAsArrayBuffer(file);
  //   });
  // };
  //---------New Code for validateExcelHeaders-------------
  const validateExcelHeaders = (file) => {
    return new Promise((resolve, reject) => {
      // Check file type
      // const isExcel =
      //   file.type ===
      //     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      //   file.name.endsWith('.xlsx');

      // if (!isExcel) {
      //   reject('Invalid file type. Please upload an Excel file.');
      //   return;
      // }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          let allErrors = [];
          let extractedData = [];
          console.log('workbook:', workbook);
          // Process each sheet
          workbook.SheetNames.forEach((sheetName) => {
            const worksheet = workbook.Sheets[sheetName];
            console.log(`Analyzing sheet: ${sheetName}`);

            const range = XLSX.utils.decode_range(worksheet['!ref']);
            let sheetWatermarkFound = false;

            // First check for watermarks
            for (
              let row = range.s.r;
              row <= range.e.r && !sheetWatermarkFound;
              row++
            ) {
              for (let col = range.s.c; col <= range.e.c; col++) {
                const cellRef = XLSX?.utils?.encode_cell({ r: row, c: col });
                const cell = worksheet[cellRef];

                if (
                  cell?.v &&
                  typeof cell?.v === 'string' &&
                  cell?.v?.toLowerCase().includes('watermark')
                ) {
                  allErrors.push({
                    type: 'watermark',
                    sheet: sheetName,
                    message: `Watermark found in sheet "${sheetName}"`,
                  });
                  sheetWatermarkFound = true;
                  break;
                }
              }
            }

            // Only proceed with other validations if no watermark found
            if (!sheetWatermarkFound) {
              try {
                // Find headers
                const headerLocations = findHeaderLocations(worksheet);
                console.log('Header locations:', headerLocations);
                // Check for missing headers
                Object.keys(expectedHeaders).forEach((category) => {
                  if (!headerLocations[category]) {
                    allErrors.push({
                      fileName: file.name,
                      type: 'missingHeader',
                      sheet: sheetName,
                      category,
                      message: `Missing column '${category}' in sheet "${sheetName}"`,
                    });
                  }
                });

                // Check for images in data columns
                for (let row = range.s.r; row <= range.e.r; row++) {
                  for (let col = range.s.c; col <= range.e.c; col++) {
                    const cellRef = XLSX?.utils?.encode_cell({
                      r: row,
                      c: col,
                    });
                    const cell = worksheet[cellRef];

                    if (!cell) continue;

                    Object.entries(headerLocations).forEach(
                      ([category, location]) => {
                        if (col === location.col && row > location.row) {
                          const hasImage =
                            cell.t === 'e' ||
                            (cell.l &&
                              /\.(png|jpg|jpeg|gif|bmp)$/i.test(
                                cell.l.Target,
                              )) ||
                            cell._type === 'image' ||
                            (cell?.v &&
                              typeof cell?.v === 'string' &&
                              cell?.v.includes('BITMAP'));

                          if (hasImage) {
                            allErrors.push({
                              type: 'image',
                              sheet: sheetName,
                              category,
                              cell: cellRef,
                              row: row + 1,
                              col: XLSX.utils.encode_col(col),
                              message: `Image found in "${category}" column at cell ${XLSX.utils.encode_col(col)}${row + 1} in sheet "${sheetName}"`,
                            });
                          }
                        }
                      },
                    );
                  }
                }

                // If no errors, extract data
                if (allErrors.length === 0) {
                  const sheetData = extractColumnData(
                    worksheet,
                    headerLocations,
                    expectedHeaders,
                  );
                  console.log('Sheet Data@@@@@@@@@:', sheetData);

                  let fileName = file.name;
                  let extension = '';

                  // Extract base name and extension correctly
                  const lastDotIndex = fileName.lastIndexOf('.');
                  if (lastDotIndex !== -1) {
                    extension = fileName.slice(lastDotIndex + 1); // Get file extension
                    fileName = fileName.slice(0, lastDotIndex); // Get base name without extension
                  }

                  // Escape special characters for regex
                  const escapedFileName = fileName.replace(
                    /[-[\]{}()*+?.,\\^$|#\s]/g,
                    '\\$&',
                  );

                  // Find existing files with the same base name
                  const existingFiles = fileList.filter((item) =>
                    new RegExp(
                      `^${escapedFileName}(#\\d+)?\\.${extension}$`,
                    ).test(item.name),
                  );

                  // Find the highest duplicate number
                  let maxDuplicateNumber = 0;
                  existingFiles.forEach((item) => {
                    const match = item.name.match(
                      new RegExp(`^${escapedFileName}#(\\d+)\\.${extension}$`),
                    );
                    if (match) {
                      const number = parseInt(match[1], 10);
                      if (!isNaN(number)) {
                        maxDuplicateNumber = Math.max(
                          maxDuplicateNumber,
                          number,
                        );
                      }
                    }
                  });

                  // Generate new filename
                  let newFileName = `${fileName}.${extension}`;
                  if (existingFiles.length > 0) {
                    newFileName = `${fileName}#${maxDuplicateNumber + 1}.${extension}`;
                  }

                  if (Array.isArray(sheetData) && sheetData.length > 0) {
                    const mappedData = sheetData.map((item) => ({
                      ...item,
                      fileUid: file.uid,
                      fileName: newFileName,
                      sheetName,
                    }));

                    if (Array.isArray(extractedData)) {
                      extractedData.push(...mappedData);
                    } else {
                      extractedData = mappedData;
                    }
                  }
                }
              } catch (error) {
                if (error.message.startsWith('{')) {
                  const errorData = JSON.parse(error.message);
                  if (errorData.type === 'duplicate') {
                    allErrors.push({
                      fileName: file.name,
                      type: 'duplicate',
                      sheet: sheetName,
                      message: `Duplicate column "${errorData.header}" found in sheet "${sheetName}". First occurrence at cell ${errorData.firstLocation}, duplicate at cell ${errorData.duplicateLocation}`,
                    });
                  }
                }
                // Skip further processing for this sheet
                return;
              }
            }
          });

          // Handle errors or success
          // Add errors to the global list
          if (allErrors.length > 0) {
            allErrorsList.push(...allErrors);
            reject(new Error('Validation failed'));
          } else {
            setAllExtractedData((prev) => [...prev, ...extractedData]);
            resolve();
          }
        } catch (error) {
          const errorMessage = error.message.includes(
            "Cannot read properties of undefined (reading 'indexOf')",
          )
            ? 'Unable to process the file due to its invalid format.'
            : error.message;

          allErrorsList.push({
            fileName: file.name,
            type: 'fileError',
            message: ` : ${errorMessage}`,
          });

          reject(error);
        }
      };

      reader.readAsArrayBuffer(file);
    });
  };

  // Show all errors in a single popup after all files are processed
  // const showErrorPopup = () => {
  //   // Remove existing popup if already present
  //   const existingPopup = document.querySelector('.popup-overlay');
  //   if (existingPopup) {
  //     existingPopup.remove();
  //   }

  //   if (allErrorsList.length > 0) {
  //     const errorPopup = document.createElement('div');
  //     errorPopup.classList.add('popup-overlay');

  //     // Generate error messages for display
  //     const errorMessages = allErrorsList
  //       .map(
  //         (error) =>
  //           `<p><strong>${error.fileName}</strong>: ${error.message}</p>`,
  //       )
  //       .join('');

  //     errorPopup.innerHTML = `
  //     <div class="popup-container">
  //       <button class="popup-close">&times;</button>
  //       <h2 class="popup-heading">File Upload Errors</h2>
  //       <p class="popup-para">Please correct the following issues:</p>
  //       <div class="popup-message">${errorMessages}</div>
  //       <button class="download-errors">Download</button>
  //     </div>
  //   `;

  //     // Append the popup to the body
  //     document.body.appendChild(errorPopup);

  //     // Apply styles for the download button
  //     document.querySelector('.download-errors').style.cssText = `
  //     background-color: #1C4E9D;
  //     color: white;
  //     padding: 10px 16px;
  //     border: none;
  //     border-radius: 5px;
  //     cursor: pointer;
  //     margin-top: 12px;
  //     font-size: 14px;
  //     display: block;
  //     width: 100%;
  //     text-align: center;
  //   `;

  //     // Close button functionality with confirmation popup
  //     document.querySelector('.popup-close').addEventListener('click', () => {
  //       errorPopup.remove();
  //       allErrorsList.length = 0; // Clear errors after closing
  //     });

  //     // Download Errors Button Functionality
  //     document
  //       .querySelector('.download-errors')
  //       .addEventListener('click', () => {
  //         const doc = new jsPDF();
  //         doc.setFontSize(14);
  //         doc.text('File Upload Errors', 10, 10);
  //         doc.setFontSize(10);

  //         // Format errors for PDF
  //         let y = 20;
  //         allErrorsList.forEach((error, index) => {
  //           doc.text(
  //             `${index + 1}. ${error.fileName}: ${error.message}`,
  //             10,
  //             y,
  //           );
  //           y += 10; // Move text down for next error
  //         });

  //         doc.save('file_errors.pdf');
  //       });
  //   }
  // };

  const showErrorPopup = () => {
    // Remove existing popup if already present
    const existingPopup = document.querySelector('.popup-overlay');
    if (existingPopup) {
      existingPopup.remove();
    }

    if (allErrorsList.length > 0) {
      const errorPopup = document.createElement('div');
      errorPopup.classList.add('popup-overlay');

      // Prioritize watermark errors
      const watermarkErrors = allErrorsList.filter(
        (e) => e.type === 'watermark',
      );
      const otherErrors = allErrorsList.filter((e) => e.type !== 'watermark');

      const errorMessages =
        watermarkErrors.length > 0
          ? watermarkErrors
              .map(
                (error) =>
                  `<p style="color: red"><strong>${error.fileName}</strong>: ${error.message}</p>`,
              )
              .join('') +
            otherErrors
              .map(
                (error) =>
                  `<p><strong>${error.fileName}</strong>: ${error.message}</p>`,
              )
              .join('')
          : allErrorsList
              .map(
                (error) =>
                  `<p><strong>${error.fileName}</strong>: ${error.message}</p>`,
              )
              .join('');

      errorPopup.innerHTML = `
        <div class="popup-container">
          <button class="popup-close">&times;</button>
          <h2 class="popup-heading">File Upload Errors</h2>
          <p class="popup-para">Please correct the following issues:</p>
          <div class="popup-message">${errorMessages}</div>
          <button class="download-errors">Download</button>
        </div>
      `;

      // Append the popup to the body
      document.body.appendChild(errorPopup);

      // Apply styles for the download button
      document.querySelector('.download-errors').style.cssText = `
        background-color: #1C4E9D;
        color: white;
        padding: 10px 16px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        margin-top: 12px;
        font-size: 14px;
        display: block;
        width: 100%;
        text-align: center;
      `;

      // Close button functionality with confirmation popup
      document.querySelector('.popup-close').addEventListener('click', () => {
        errorPopup.remove();
        allErrorsList.length = 0; // Clear errors after closing
      });

      // Download Errors Button Functionality
      document
        .querySelector('.download-errors')
        .addEventListener('click', () => {
          const doc = new jsPDF();
          doc.setFontSize(14);
          doc.text('File Upload Errors', 10, 10);
          doc.setFontSize(10);

          // Format errors for PDF
          let y = 20;
          allErrorsList.forEach((error, index) => {
            doc.text(
              `${index + 1}. ${error.fileName}: ${error.message}`,
              10,
              y,
            );
            y += 10; // Move text down for next error
          });

          doc.save('File Correction_List.pdf');
        });
    }
  };

  // Function to show the confirmation popup
  const showConfirmationPopup = (onConfirm) => {
    const confirmationPopup = document.createElement('div');
    confirmationPopup.classList.add('popup-overlay');

    confirmationPopup.innerHTML = `
    <div class="popup-container">
      <h2 class="popup-heading">Are you sure?</h2>
      <p class="popup-para">Do you want to continue without downloading the errors file?</p>
      <div class="popup-buttons">
        <button class="confirm-no">No</button>
        <button class="confirm-yes">Yes</button>
      </div>
    </div>
  `;

    document.body.appendChild(confirmationPopup);

    // Apply styles for the buttons
    document.querySelector('.confirm-yes').style.cssText = `
    background-color: #1C4E9D;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    margin-left: 10px;
  `;

    document.querySelector('.confirm-no').style.cssText = `
    background-color: #1C4E9D;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
  `;

    // Align buttons to the right
    document.querySelector('.popup-buttons').style.cssText = `
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
  `;

    // Yes Button - Closes the popup
    document.querySelector('.confirm-yes').addEventListener('click', () => {
      confirmationPopup.remove();
      onConfirm(); // Proceed with closing the error popup
    });

    // No Button - Keeps the error popup open
    document.querySelector('.confirm-no').addEventListener('click', () => {
      confirmationPopup.remove();
    });
  };

  console.log('isError', isError);

  /*PREVIOUS HANDLE CHANGE FUNCTION */
  // const handleChange = ({ file, fileList: updatedList }) => {
  //   if (file.status === 'uploading') {
  //     setIsUploading(true);
  //     setFileList((prevList) => {
  //       const isFileInList = prevList.some((item) => item.uid === file.uid);

  //       if (!isFileInList) {
  //         return [...prevList, { ...file, percent: 0, status: 'uploading' }];
  //       }
  //       return prevList;
  //     });

  //     const interval = setInterval(() => {
  //       setFileList((prevList) =>
  //         prevList.map((item) => {
  //           if (item.uid === file.uid && item.percent < 100) {
  //             return { ...item, percent: item.percent + 10 };
  //           } else if (item.uid === file.uid && item.percent >= 100) {
  //             clearInterval(interval);
  //             return { ...item, percent: 100, status: 'done' };
  //           }
  //           return item;
  //         }),
  //       );
  //     }, 500);
  //   }

  //   if (file.status === 'done') {
  //     setIsUploading(false);
  //     setFileList((prevList) =>
  //       prevList.map((item) =>
  //         item.uid === file.uid
  //           ? { ...item, status: 'done', percent: 100 }
  //           : item,
  //       ),
  //     );
  //   }

  //   if (file.status === 'removed') {
  //     setIsUploading(false);
  //     setFileList((prevList) =>
  //       prevList.filter((item) => item.uid !== file.uid),
  //     );

  //     // Remove the corresponding extracted data from allExtractedData based on fileUid
  //     setAllExtractedData((prevData) =>
  //       prevData.filter((dataItem) => dataItem.fileUid !== file.uid),
  //     );
  //   }
  // };
  const handleChange = ({ file }) => {
    if (file.status === 'uploading') {
      setIsUploading(true);

      setFileList((prevList) => {
        let fileName = file.name;
        let extension = '';

        // Extract base name and extension correctly
        const lastDotIndex = fileName.lastIndexOf('.');
        if (lastDotIndex !== -1) {
          extension = fileName.slice(lastDotIndex + 1); // Get file extension
          fileName = fileName.slice(0, lastDotIndex); // Get base name without extension
        }

        // Escape special characters for regex
        const escapedFileName = fileName.replace(
          /[-[\]{}()*+?.,\\^$|#\s]/g,
          '\\$&',
        );

        // Find existing files with the same base name
        const existingFiles = prevList.filter((item) =>
          new RegExp(`^${escapedFileName}(#\\d+)?\\.${extension}$`).test(
            item.name,
          ),
        );

        // Find the highest duplicate number
        let maxDuplicateNumber = 0;
        existingFiles.forEach((item) => {
          const match = item.name.match(
            new RegExp(`^${escapedFileName}#(\\d+)\\.${extension}$`),
          );
          if (match) {
            const number = parseInt(match[1], 10);
            if (!isNaN(number)) {
              maxDuplicateNumber = Math.max(maxDuplicateNumber, number);
            }
          }
        });

        // Generate new filename
        let newFileName = `${fileName}.${extension}`;
        if (existingFiles.length > 0) {
          newFileName = `${fileName}#${maxDuplicateNumber + 1}.${extension}`;
        }

        // Ensure the file is not already in the list
        const isFileInList = prevList.some((item) => item.uid === file.uid);

        if (!isFileInList) {
          return [
            ...prevList,
            { ...file, name: newFileName, percent: 0, status: 'uploading' },
          ];
        }
        return prevList;
      });

      // Simulate progress
      const interval = setInterval(() => {
        setFileList((prevList) =>
          prevList.map((item) => {
            if (item.uid === file.uid && item.percent < 100) {
              return { ...item, percent: item.percent + 10 };
            } else if (item.uid === file.uid && item.percent >= 100) {
              clearInterval(interval);
              return { ...item, percent: 100, status: 'done' };
            }
            return item;
          }),
        );
      }, 500);
    }

    if (file.status === 'done') {
      setIsUploading(false);
      setFileList((prevList) =>
        prevList.map((item) =>
          item.uid === file.uid
            ? { ...item, status: 'done', percent: 100 }
            : item,
        ),
      );
    }

    if (file.status === 'removed') {
      setIsUploading(false);
      setFileList((prevList) =>
        prevList.filter((item) => item.uid !== file.uid),
      );

      // Remove the corresponding extracted data from allExtractedData based on fileUid
      setAllExtractedData((prevData) =>
        prevData.filter((dataItem) => dataItem.fileUid !== file.uid),
      );
    }
  };

  // const handleRemove = (file) => {
  //   // Remove the file from the file list
  //   setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));

  //   // Remove the extracted data corresponding to the deleted file
  //   setAllExtractedData((prevData) =>
  //     prevData.filter((dataItem) => dataItem.fileUid !== file.uid),
  //   );

  //   // Optionally, store deleted file info if you want to track removed files
  //   setDeletedFiles((prevDeleted) => [...prevDeleted, file]);
  // };

  const handleRemove = (file) => {
    setFileList((prevList) => {
      // Remove the selected file from the list
      let updatedList = prevList.filter((item) => item.uid !== file.uid);

      // Extract base name and extension of the deleted file
      let baseName = file.name;
      let extension = '';

      if (file.name.includes('.')) {
        const fileParts = file.name.split('.');
        extension = fileParts.pop(); // Get file extension
        baseName = fileParts.join('.').split('#')[0]; // Get base name without numbering
      }

      // Get all remaining files with the same base name
      let sameBaseFiles = updatedList.filter((item) => {
        let itemBaseName = item.name.includes('#')
          ? item.name.split('#')[0]
          : item.name.split('.')[0];

        return itemBaseName === baseName;
      });

      // Sort files to maintain order
      sameBaseFiles.sort((a, b) => a.name.localeCompare(b.name));

      // Renumber files sequentially
      sameBaseFiles.forEach((item, index) => {
        if (index === 0) {
          item.name = `${baseName}.${extension}`; // First file keeps original name
        } else {
          item.name = `${baseName}#${index}.${extension}`;
        }
      });

      return [...updatedList];
    });

    // Remove extracted data corresponding to the deleted file
    setAllExtractedData((prevData) =>
      prevData.filter((dataItem) => dataItem.fileUid !== file.uid),
    );

    // Track deleted files (if needed)
    setDeletedFiles((prevDeleted) => [...prevDeleted, file]);
  };

  const props = {
    name: 'file',
    multiple: true,
    showUploadList: false,
    action: null, // Prevents automatic upload to any endpoint
    onChange: handleChange,
    beforeUpload: (file) => {
      return new Promise((resolve, reject) => {
        validateExcelHeaders(file)
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            showErrorPopup(); // Show the consolidated error popup after all files are processed
          });
      });
    },
    customRequest: ({ onSuccess }) => {
      setIsUploading(true);
      setTimeout(() => {
        onSuccess('ok');
      }, 2000);
    },
  };

  const handleDownload = () => {
    const fileUrl = '/Standard Format_BBS.xlsx'; // File should be inside the "public" folder
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'Standard Format_BBS.xlsx'; // File name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const VaritionFileDownload = () => {
    const fileUrl = '/Variations_File.pdf'; // File should be inside the "public" folder
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'Variations - Mandatory 3 Columns in Standard File.pdf'; // File name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div className="">
        <div className="flex items-center justify-between mt-[-10px]">
          <p className="text-[#1C4E9D] text-[18px] font-['SF-Pro-Text-Regular, sans-serif'] font-bold">
            Rules to upload files
          </p>
          <div className="flex flex-col gap-y-2 mt-2">
            <Tooltip title="It is advisable to follow 'Standard BBS Format' to upload BBS files">
              <button onClick={handleDownload} className="bg-[#FFFFFF] border border-[#D0D5DD] w-auto px-2 py-1">
                <div className="flex items-center gap-x-1">
                  <img
                    className="h-[15px] w-[15px] md:h-[20px] md:w-[20px]"
                    src={button_icon}
                    
                    alt="Standard File"
                  />
                  <p className="text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] md:text-[14px] text-[10px]">
                    Standard File
                  </p>
                </div>
              </button>
            </Tooltip>

            <Tooltip title="Variations for the three mandatory columns in the standard file.">
              <button onClick={VaritionFileDownload} className="bg-[#FFFFFF] border border-[#D0D5DD] w-auto px-2 py-1">
                <div className="flex items-center gap-x-1">
                  <img
                    className="h-[15px] w-[15px] md:h-[20px] md:w-[20px]"
                    src={button_icon}
                    
                    alt="Variations File"
                  />
                  <p className="text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] md:text-[14px] text-[10px]">
                    Variations File
                  </p>
                </div>
              </button>
            </Tooltip>
          </div>
        </div>
        <div className=" leading-[15px]">
          <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            1. The file must be uploaded in excel format only.
          </p>
          <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            2. The file must contain three columns: Rebar Dia, Cutting Length,
            and No. of bars.
          </p>
          <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            3. Files will be rejected if any of these headers are missing (Rebar
            Dia, Cutting Length, and No. of bars).
          </p>
          <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            4. The column headers in the file must match the specified
            variations exactly. Any mismatch will result in the rejection of the
            file.
          </p>
          <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            5. Files will be rejected if any of the three columns (Rebar Dia,
            Cutting Length, and No. of bars) contain string values and images.
            The value should only be a number and not have letters or symbols
            (*, & %, $ etc) - “10”, ”25”, ”970”, “1170” etc.
          </p>
          <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            6. The file or any of its sheets must not be password-protected.
          </p>
          <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            7. The file should not have any duplicate column headers (Rebar Dia,
            Cutting Length, and No. of bars).
          </p>
          {/* <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            8. The file or any of its sheets must not have filters applied to
            the three columns (Size, Total No. of Bars, Total Length of Bars).
          </p>
          <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            9. The file must not have any missing data in any of the three
            columns (Size, Total No. of Bars, Total Length of Bars).
          </p>
          <p className="text-[#667085] font-['SF-Pro-Text-Regular, sans-serif'] text-[13px] mb-[15px] leading-5">
            10. The file must not contain images in any of the three columns
            (Size, Total No. of Bars, Total Length of Bars).
          </p> */}
        </div>

        {/* <div className="flex items-center mt-4">
          <input
            type="checkbox"
            id="agree"
            className="mr-2 checkbox"
            onChange={handleCheckboxChange}
            checked={isChecked}
          />
          <label
            htmlFor="agree"
            className=" text-[#667085] text-[13px] font-['SF-Pro-Text-Regular, sans-serif']"
          >
            I agree
          </label>
        </div> */}
      </div>
      <Form form={form} layout="vertical" className="mt-3">
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24} sm={12}>
            <Form.Item valuePropName="fileList">
              <Dragger
                {...props}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                //disabled={!isChecked}
              >
                <p className="flex items-center justify-center ant-upload-drag-icon">
                  <img src={featured_icon} alt="upload-icon" />
                </p>
                <p className="ant-upload-text">Click to upload</p>
                {/* <p className="ant-upload-hint">SNG, PNG, JPG, or GIF (max 800x400px)</p> */}
              </Dragger>

              <div
                className="uploaded-files"
                style={{
                  maxHeight: '200px', // adjust the height as necessary
                  overflowY: 'auto', // make the list scrollable if needed
                }}
              >
                {fileList.map((file) => (
                  <div key={file.uid} className="file-item">
                    <div className="file-info">
                      {/*  {console.log(file)} */}
                      <div className="file-details">
                        <span className="file-name">{file.name}</span>
                        <span className="file-size">{file.size} KB</span>
                      </div>
                    </div>
                    <div className="progression-bar">
                      <DeleteOutlined onClick={() => handleRemove(file)} />

                      {file.status === 'uploading' && (
                        <CustomProgress percent={file.percent} />
                      )}

                      {file.status === 'done' && (
                        <CheckCircleOutlined style={{ color: 'green' }} />
                      )}
                      {file.status === 'error' && (
                        <CloseCircleOutlined style={{ color: 'red' }} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default UploadFiles;
